// extracted by mini-css-extract-plugin
export var button = "Post-module--button--27HfC";
export var comments = "Post-module--comments--2bE-0";
export var content = "Post-module--content--3cRzw";
export var footer = "Post-module--footer--NpFTW";
export var post = "Post-module--post--mo55f";